import { useContext } from 'react';
import { CollaboratorsContext } from '../contexts/collaborators_context';

const useCollaborators = () => {
    return useContext(CollaboratorsContext);
};

export default useCollaborators;
